import React, { useEffect, useState } from "react";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { caseActions } from "@_actions/case.actions";
import { casesActions } from "@_actions/cases.actions";

function CancelCasePopup(props) {
  const { overviewData, caseId } = props;
  const dispatch = useDispatch();
  const [cancelInProgress, setCancelInProgress] = useState(false);
  const caseReducer = useSelector((state) => state.caseReducer);

  function actionClicked() {
    setCancelInProgress(true);
    dispatch(caseActions.updateCaseStateCancel(caseId));
    setTimeout(() => {}, 100);
  }

  /**
   * Cancel-case result handler.
   * Why: reacts to `CASE_UPDATE_STATE_CANCEL` and refreshes lists/details, closes popup, or shows error.
   * When: on `cancelInProgress` and status changes (runs whenever deps change).
   * Also observed in OverviewSection and other list views that depend on case status.
   * Risks: popup may close before refetch finishes; alert blocks UI; repeated dispatches if status not cleared.
   * Fix:  replace alert with snackbar;
   */
  useEffect(() => {
    if (
      cancelInProgress &&
      caseReducer.status.CASE_UPDATE_STATE_CANCEL === "success"
    ) {
      dispatch(caseActions.clearStateMessage("CASE_UPDATE_STATE_CANCEL"));
      dispatch(casesActions.getCases());
      dispatch(casesActions.getCasesCount());
      dispatch(caseActions.getCaseWithChargeDetails(caseId, overviewData));
      props.close();
    } else if (
      cancelInProgress &&
      caseReducer.status.CASE_UPDATE_STATE_CANCEL !== "success" &&
      caseReducer.status.CASE_UPDATE_STATE_CANCEL !== "request" &&
      caseReducer.status.CASE_UPDATE_STATE_CANCEL !== ""
    ) {
      dispatch(caseActions.clearStateMessage("CASE_UPDATE_STATE_CANCEL"));
      //error occured
      window.alert("Cancel case failed. Try again later.");
    }
  }, [
    cancelInProgress,
    caseId,
    caseReducer.status.CASE_UPDATE_STATE_CANCEL,
    dispatch,
    overviewData,
    props,
  ]);

  return (
    <DialogPopup
      title="Cancel Case"
      open={props.open}
      onClose={() => props.close()}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          actionClicked();
        }
      }}
    >
      <div>Are you sure you want to cancel this case?</div>
      <div className="action_container">
        <Button className="btn_cancel" onClick={() => props.close()}>
          No
        </Button>
        <Button className="btn_confirm" onClick={actionClicked}>
          Yes
        </Button>
      </div>
    </DialogPopup>
  );
}

export default CancelCasePopup;
